module.exports = __webpack_public_path__ + "static/media/11_nature.0594538c.jpg";